var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 8.44772 18.5523 8 18 8H6C5.44772 8 5 8.44772 5 9C5 9.55228 5.44772 10 6 10H18C18.5523 10 19 9.55228 19 9ZM14.5 15C14.5 14.4477 14.0523 14 13.5 14H6C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16H13.5C14.0523 16 14.5 15.5523 14.5 15Z",
    fill: "#646A82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/Menu2.33b188f3c56adb46cffe532706a347f3.svg";
export { ForwardRef as ReactComponent };